module.exports = __webpack_public_path__ + "img/65.fe09135c.jpg";